import type { TPostConditionSetProps } from './ConditionSet.types';

const ConditionSet = ({ children }: TPostConditionSetProps) => {
  return children;
};

export { ConditionSet };
